// extracted by mini-css-extract-plugin
module.exports =  {"root":"pdsldAyp4ioPTmuBrGIz"};